// extracted by mini-css-extract-plugin
export default {"imageWrapper":"nL-z","twoColumnImage":"oL-z"};